import PropTypes from 'prop-types';
import cx from 'classnames';

import sty from './StatusBadge.module.scss';

// Numeric campaign status → semantic bucket. Matches the legend in
// pages/campaigns/index.jsx (CAMPAIGN_STATUS) and the wider portal's
// traffic-light convention.
const STATUS_TO_VARIANT = {
  1: 'draft', // Draft
  2: 'draft', // Pending launch — same amber as draft
  3: 'live', // Launched
  5: 'live', // Active
  7: 'stopped', // Stopped
  8: 'expired', // Expired
  9: 'expired', // Terminal
};

function resolveVariant({ variant, status }) {
  if (variant) return variant;
  if (status != null && STATUS_TO_VARIANT[status]) return STATUS_TO_VARIANT[status];
  return 'expired';
}

function StatusBadge({ status, variant, children, className }) {
  const v = resolveVariant({ variant, status });
  return <span className={cx(sty.badge, sty[v], className)}>{children}</span>;
}

StatusBadge.propTypes = {
  status: PropTypes.number,
  variant: PropTypes.oneOf(['draft', 'live', 'stopped', 'expired']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default StatusBadge;
